import { gql } from "@apollo/client";

/**
 * Single round trip for the System Hero banner's lead state: contract state and
 * live connection status. networkInformation is intentionally NOT included —
 * it resolves noticeably slower and streams in via SystemNetworkInfo instead.
 */
export const SystemDashboardHero = gql`
    query SystemDashboardHero($id: ID!) {
        system(id: $id) {
            id
            client {
                id
                industryType
                contract {
                    id
                    contractDurationFrom
                    contractDurationTo
                }
            }
            iotConnection {
                id
                connectionStatus
            }
        }
    }
`;
